import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { DatePickerSelectors } from './DatePickerSelectors';

import ResultsTable from './ResultsTable';
import SearchResults from '../../../SearchResults';
import Warning from '../../../../../components/Warning2';
import TextInput from '../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../components/ZUILib/InputButton';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import CalenderSample from '../../../../../components/ZUILib/CalenderSample/CalenderSample';
import Pagination from '../../../../../components/Pagination';

import commonUtil from '../../../../../utils/commonUtil';
import errorlabels from '../../../../../utils/errors/LP_GR_error.json';
import Tagging from '../../../../../components/Tagging/Tagging';
import * as defaultConst from '../../../../../utils/clientConstant';
import MonthRangePicker from '../../../../../components/ZUILib/MonthRangePicker';
import GiftListConfigureWapModal from '../../../../eventManagement/page/GiftList/wapComponents/GiftListConfigureWapModal';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import _ from 'lodash';

const applicationRoutes = commonUtil.getApplicationRoutes();

const eventStatusforGuestViewAvailable = [
  defaultConst.eventStatus.ACTIVE,
  defaultConst.eventStatus.ADMINISTRATIVE_PROCESS,
  "ACTIVE",
  defaultConst.eventStatus.UNDER_REVIEW
];

const RESULTS_PER_PAGE = '30';

const RESULTS = {
     IS_FOUND: true,     
};

  const months = [
    { name: "Ene", value: 0 }, { name: "Feb", value: 1 }, { name: "Mar", value: 2 },
    { name: "Abr", value: 3 }, { name: "May", value: 4 }, { name: "Jun", value: 5 },
    { name: "Jul", value: 6 }, { name: "Ago", value: 7 }, { name: "Sep", value: 8 },
    { name: "Oct", value: 9 }, { name: "Nov", value: 10 }, { name: "Dic", value: 11 }
  ];
const eventStatusforGuestViewNotAvailable = [
  defaultConst.eventStatus.SUSPENDED,
  defaultConst.eventStatus.DELETED,
  defaultConst.eventStatus.DELETED_BY_FRAUD,
  defaultConst.eventStatus.VALIDITY_OFF_ACTIVE,
  defaultConst.eventStatus.CLOSED,
  defaultConst.eventStatus.TEMPORARY_CLOSED,
  defaultConst.eventStatus.SUSPENDED_FOR_TIME,
];

@connect(store => ({
    lables: store.labels.data,
    user: store.user.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
    globleObj: store.globleObject,
    stateList: store.createEvent.dataState,
    storeList: store.createEvent.dataStore,
    createEventObject: store.createEventObject,
    eventCategory: store.eventcategory.data,
    isColorPickerOpen: store.createEvent.isColorPickerOpen
}))

class EventSearchForm extends Component {
  constructor(props) {
    super(props);
    this.calendar = {
      maxDays: '',
      minDays: '',
    };
    const { filterProductSearchResultStore = {} } = this.props;

    this.errorMessage = '';
    this.slctDateBefore = null;
    this.slctDateAfter = null;
    this.txtNameTouched = false;
    this.txtLastNameTouched = false;
    this.motherNameTouched = false;
    this.state = {
      eventId: '',
      selectedEventType: 'Todos los eventos',
      btnDisabled: true,
      divIdDisabled: 'block',
      divDataDisabled: 'none',
      isSearchForId: true,
      eventsReorderBtn: !!filterProductSearchResultStore || !!filterProductSearchResultStore.events,
      MonthRangePicker : false,
      startDate : "",
      endDate : "",
      startMonthName: '',
      endMonthName : '',
      shareModal:false,
      showFieldLevelError: false
    };
  }

  calculateFormValidity = () => {
    const txtName = this.txtName.getValue();
    const motherName = this.motherName.getValue();
    const txtLastName = this.txtLastName.getValue();
    const validInputs = [txtLastName, motherName, txtName].filter(x => x.length >= 3).length;
    const emptyInputs = [txtLastName, motherName, txtName].filter(x => x.length === 0).length;
    const isThreeFilled = 
      (validInputs === 1 && emptyInputs === 2) ||
      (validInputs === 2 && emptyInputs === 1) ||
      (validInputs === 3);
    return isThreeFilled || 
      (emptyInputs === 3 && this.state.selectedEventType !== 'Todos los eventos') || 
      (emptyInputs === 3 && this.state.startDate) || 
      (emptyInputs === 3 && this.state.endDate);
  }

  setStartDateAndEndDate = (date) => {
    if(date && date.start && date.end) {
      this.setState({startDate:date.start,endDate:date.end,startMonthName:date.startMonthName,endMonthName:date.endMonthName});
    }
    else {
      this.setState({startDate:"",endDate:"",startMonthName:"",endMonthName:""});
    }
    
  }

  compareEventStatus = (eventStatus, possibleStatus) => {
    if (!eventStatus) {
      return false;
    }
    if (Array.isArray(possibleStatus)) {
      return possibleStatus.filter(status => status.toUpperCase() === eventStatus.toUpperCase()).length;
    }
    return possibleStatus.toUpperCase() === eventStatus.toUpperCase();
  };

  // validateMotherName = () => {
  //   let motherNameValidationRules = '';
  //   if (this.motherName.getValue().trim().length === 0) return;

  //   if (this.motherName.getValue().trim().length > 0) {
  //     motherNameValidationRules = [{
  //       functionRef: commonUtil.validateName,
  //       funcData: [this.motherName.getValue(), 3, true],
  //       errorMessage: commonUtil.getError(errorlabels.eventSearch, 'ca.eventSearch.lastName.invalid'),
  //     }];

  //     const isMotherNameValid = commonUtil.validateTextInput(motherNameValidationRules, this.motherName, null);
  //     return true;
  //   }
  // }

  eventSearch =  () => {
    const eventSearchData = {};
    // let firstNameValidationRules = '';
    // if (this.txtName.getValue().trim().length > 0) {
    //   firstNameValidationRules = [{
    //     functionRef: commonUtil.validateName,
    //     funcData: [this.txtName.getValue(), 3, true],
    //     errorMessage: commonUtil.getError(errorlabels.eventSearch, 'ca.eventSearch.firstName.invalid'),
    //   }];
    // } else {
    //   this.warning.setMessage('El nombre es requerido');
    // }

    // const isFirstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.txtName, null);
    // let lastNameValidationRules = '';

    // if (this.txtLastName.getValue().trim().length > 0) {
    //   lastNameValidationRules = [{
    //     functionRef: commonUtil.validateName,
    //     funcData: [this.txtLastName.getValue(), 3, true],
    //     errorMessage: commonUtil.getError(errorlabels.eventSearch, 'ca.eventSearch.lastName.invalid'),
    //   }];
    // } else if (isFirstNameValid) {
    //   this.warning.setMessage('El apellido paterno es requerido');
    // }

    // const isLastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.txtLastName, null);
    // const isMotherNameValid = this.validateMotherName();

    // if (isFirstNameValid) {
    //   eventSearchData.firstNameOrNickName = this.txtName.getValue().toLowerCase();
    // }

    // if (isLastNameValid) {
    //   eventSearchData.lastNameOrPaternalName = this.txtLastName.getValue().toLowerCase();
    // }

    // if (isMotherNameValid) {
    //   eventSearchData.motherName = this.motherName.getValue();
    // }

    eventSearchData.pageNum = '1';
    eventSearchData.resultsPerPage = RESULTS_PER_PAGE;
    eventSearchData.eventType = this.state.selectedEventType != 'Todos los eventos' ? this.state.selectedEventType : '';
    eventSearchData.motherName = this.motherName.getValue() ? this.motherName.getValue() : '';
    eventSearchData.eventDateStartRange = this.state.startDate || this.slctDateBefore && this.slctDateBefore.value || '';
    eventSearchData.eventDateEndRange = this.state.endDate || this.slctDateAfter && this.slctDateAfter.value || '';
    eventSearchData.firstNameOrNickName = this.txtName.getValue().toLowerCase();
    eventSearchData.lastNameOrPaternalName = this.txtLastName.getValue().toLowerCase();

    // if (isMotherNameValid !== false) {
      this.props.serchEventData(eventSearchData);
    // }

    const dataLayer = {
      event: 'comprar_para_mesa_de_regalos',
      seccion: 'Mesa de regalos',
      phase: 'Busqueda de mesa',
      step: 'Busqueda de mesa por nombre',
    };
    window.dataLayer.push(dataLayer);
  }

  eventSearchById = () => {
    const eventSearchData = {};
    const eventSearchDataById = {};
    const eventID = this.eventId.getValue();
    eventSearchDataById.eventId = eventID;
    // eventSearchData.eventType = this.selection?.getSelectedIndex() ? this.selection?.getValue() : '';
    if (eventSearchDataById.eventId.trim().length > 0) {
      const { searchEventById } = this.props;
      searchEventById(eventSearchDataById).then((response) => {
        const eventStatus = response && response.eventInfo ? response.eventInfo.eventStatus : undefined;

        if (response.status.status === 'success' && this.compareEventStatus(eventStatus, eventStatusforGuestViewAvailable) && response.celebratedList && response.celebratedList.length > 0) {
          response.status.errorMessage = '';
        }
        if (response.status.status === 'success' && this.compareEventStatus(eventStatus, eventStatusforGuestViewAvailable) && !response.status.errorMessage) {
          browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftListGuestView, { eventID }));
        } else if (response.status.status === 'success' && this.compareEventStatus(eventStatus, eventStatusforGuestViewNotAvailable) && !response.status.errorMessage) {
          this.warning.setMessage(commonUtil.getLabel(this.props.labels.GuestviewPage, 'guestview.event.not.available.message'));
        } else if (response.status.status === 'failure') {
          const errormessage = commonUtil.getLabel(this.props.labels.GuestviewPage, response.status.errorMessage);
          const dataLayer = {
            event: 'alerta',
            seccion: 'Mesa de regalos',
            phase: 'Busqueda de mesa',
            step: 'Busqueda de mesa por numero',
            mensaje: errormessage.substring(0, 100),
            mensaje_servicio: response.status.status,
            tipo: 'Notificacion',
          };
          window.dataLayer.push(dataLayer);
          this.warning.setMessage(commonUtil.getLabel(this.props.labels.GuestviewPage, response.status.errorMessage));
        } else if (response.status.status === 'success' && response.status.errorMessage) {
          this.warning.setMessage(commonUtil.getLabel(this.props.labels.GuestviewPage, response.status.errorMessage));
        }
      }).catch((error)=>{
          var respons = error
          // this.warning.setMessage(commonUtil.getLabel(this.props.labels.GuestviewPage, error.errorMessage));
          this.warning.setMessage('Sin resultados encontrados. Rectifica los datos ó ingresa una nueva búsqueda de mesa de regalos.');

      });
      const dataLayer = {
        event: 'comprar_para_mesa_de_regalos',
        seccion: 'Mesa de regalos',
        phase: 'Busqueda de mesa',
        step: 'Busqueda de mesa por numero',
        numero_mesa: eventID,
      };
      window.dataLayer.push(dataLayer);
    } else {
      this.warning.setMessage('El número del evento es requerido');
    }
  }

  handleAllowOnlyAlpha = (event) => {
    const _char = String.fromCharCode(event.charCode);
    if (!(/^[a-zA-ZáéíóúñüÁÉÍÓÚÑÜ \s]+$/.test(_char))) {
      event.preventDefault();
    }
  }

  onPasteFuncOnlyAlpha = (event) => {
    const text = event.clipboardData.getData('Text');
    const alphaNumericValue = text ? text.replace(/[^a-zA-ZáéíóúñüÁÉÍÓÚÑÜ \s]/gi, '') : '';
    if (text !== alphaNumericValue) {
      event.preventDefault();
    }
  }

  handleAllowOnlyDigit = (e) => {
    const charCode = (e.which) ? e.which : e.keyCode;
    const keyCode = e.charCode;

    if ((charCode || keyCode) === 46) {
      e.preventDefault();
    }

    if (Number(this.eventId.getValue()) > 9999999) {
      e.preventDefault();
    }
  }

  handleAllowOnlyDigitDesktop = (e) => {
    const keyCode = e.charCode;
    if ((keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  }

  handleOnPasteInput = (event) => {
    const text = event.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    const lengthValue = this.eventId.getValue().length;
    const maxLimitValue = lengthValue === 0 ? 8 : lengthValue + 1;

    if (text !== numericValue) {
      event.preventDefault();
    }

    if (text.length > 8) {
      event.preventDefault();
    }

    if (maxLimitValue > 8) {
      event.preventDefault();
    }
  }

  handleSwitchRadio = (event) => {
    const { currentTarget: { value } } = event;
    // this.props.cleanStateWarning();

    if (value === 'id') {
      document.querySelector('#eventId').value = '';
      this.txtNameTouched = false;
      this.txtLastNameTouched = false;
      this.motherNameTouched = false;
      this.setState({ isSearchForId: true, divDataDisabled: 'none', divIdDisabled: 'block' ,selectedEventType : 'Todos los eventos',startMonthName : '',endMonthName : '',startDate : '',endDate:"" , btnDisabled: true });
    } else {
      this.txtNameTouched = false;
      this.txtLastNameTouched = false;
      this.motherNameTouched = false;
      this.setState({
        isSearchForId: false,
        divDataDisabled: 'block',
        divIdDisabled: 'none',
        btnDisabled: false,
        showFieldLevelError: false
      });
      this.txtName.clearError();
      this.txtLastName.clearError();
      this.motherName.clearError();
      this.txtLastName.setValue('');
      this.motherName.setValue('');
      this.txtName.setValue('');
      this.selection?.clearSelectedData();
    }
  }

  handleBtnSearch = () => {
    if (this.state.isSearchForId) {
      this.eventSearchById();
      return;
    }

    const txtName = this.txtName.getValue();
    const txtLastName = this.txtLastName.getValue();
    const motherName = this.motherName.getValue()
    const anyFieldFilled = txtName.length > 0 || txtLastName.length > 0 || motherName.length > 0;
    if (!anyFieldFilled) {
      this.validateNameField(this.txtName, this.txtNameTouched, txtName);
      this.validateNameField(this.txtLastName, this.txtLastNameTouched, txtLastName);
      this.validateNameField(this.motherName, this.motherNameTouched, motherName);
      this.setState({ showFieldLevelError: true });
      return;
    }
    
    this.setState({ ...this.state, eventsReorderBtn: false });
    this.eventSearch();
  }

  validateNameField = (control, touchedFlag, value) => {
   
    if (value.length === 0) {
      control.setControlState(
        false,
        commonUtil.getLabel(this.props.labels.EventSearchPage, 'event.search.minimum.three.character.length.message'),
        {
          controlErrorClass: 'error',
          errorClass: 'error-message',
        },
      );
      if (control.errorControl) {
        control.errorControl.style.display = 'block';
      }
      return;
    }

    control.setControlState(true, '', {
      controlErrorClass: 'error',
      errorClass: 'error-message',
    });
    if (control.errorControl) {
      control.errorControl.style.display = 'none';
    }
  }

  handleOnChangeBtn = (event) => {
    const { currentTarget: { value, name } } = event;
    // if (!this.props.resultsFound) this.props.cleanStateWarning();
    const { selectedEventType } = this.state;
    if (this.state.isSearchForId) {
      if (value.length >= 8) {
        this.setState({ btnDisabled: false });
        return;
      }
      this.setState({ btnDisabled: true });
      return;
    }
    const txtName = this.txtName.getValue();
    const motherName = this.motherName.getValue();
    const txtLastName = this.txtLastName.getValue();
    if (name === 'txtName') this.txtNameTouched = true;
    if (name === 'txtLastName') this.txtLastNameTouched = true;
    if (name === 'motherName') this.motherNameTouched = true;
    const regexValidation = /^[a-zA-ZáéíóúñüÁÉÍÓÚÑ ]+$/g;
    this.txtLastName.setValue(txtLastName.replace(regexValidation, ''));
    this.motherName.setValue(motherName.replace(regexValidation, ''));
    this.txtName.setValue(txtName.replace(regexValidation, ''));

    this.txtName.setValue(this.capitalizeWord(txtName));
    this.motherName.setValue(this.capitalizeWord(motherName));
    this.txtLastName.setValue(this.capitalizeWord(txtLastName));
     
    if (txtName.length > 0 || txtLastName.length > 0 || motherName.length > 0) {
    this.txtName.clearError();
    this.txtLastName.clearError();
    this.motherName.clearError();
    if (this.txtName.errorControl) this.txtName.errorControl.style.display = 'none';
    if (this.txtLastName.errorControl) this.txtLastName.errorControl.style.display = 'none';
    if (this.motherName.errorControl) this.motherName.errorControl.style.display = 'none';
    this.setState({ showFieldLevelError: false });
    }

    
  }

  enableMonthRangePicker = () =>{
    this.setState({MonthRangePicker:!this.state.MonthRangePicker});
  }
  capitalizeWord = (value) => {
    let result = '';
    if (value.length > 0) {
      result = value[0].toUpperCase().concat(value.slice(1));
    }
    return result;
  }

  handleSelectorAfter = ({ target }) => {
    this.warning.setMessage('');
    this.props.rangeOfDateEvent({
      eventDateEndRange: this.slctDateAfter.value || target.value,
      eventDateStartRange: this.slctDateBefore.value,
    });
  }

  handleSelectorBefore = ({ target }) => {
    this.warning.setMessage('');
    this.props.rangeOfDateEvent({
      eventDateStartRange: this.slctDateBefore.value || target.value,
      eventDateEndRange: this.slctDateAfter.value,
    });
  }

  handleSelectorDateBefore = optionValue => this.slctDateBefore = optionValue;

  handleSelectorDateAfter = optionValue => this.slctDateAfter = optionValue;

  handleEventIdChangeWap = (event) => {
    const eventId = event.target.value;
    const cleanedEventId = eventId.replace(/[^\d]/g, '').substring(0, 8);
    this.setState({ eventId: cleanedEventId });
  }

  handleEventIdKeyDownWap = (event) => {
    const disallowedKeys = ['e', '+', '-', ',', '.'];
    if (disallowedKeys.includes(event.key.toLowerCase())) event.preventDefault();
  }

  handleEventIdPasteWap = (event) => {
    const eventId = event.clipboardData.getData('text/plain');
    const cleanedEventId = eventId.replace(/[^\d]/g, '').substring(0, 8);
    this.setState({ eventId: cleanedEventId });
    event.preventDefault();
  }

  enableButton = () => this.setState({ btnDisabled: false });

  disableButton = () => this.setState({ btnDisabled: true });

  hasStoreData = () => {
    const { filterProductSearchResultStore, extraData , filterProductSearchResult} = this.props;
    const hasPrevData = (filterProductSearchResult?.events?.length === 0 || filterProductSearchResult?.events?.length === 1);
    const {
      eventType,
      motherName,
      eventDateEndRange,
      eventDateStartRange,
      firstNameOrNickName,
      lastNameOrPaternalName,
    } = filterProductSearchResultStore;
    
    this.slctDateBeforeStore = eventDateStartRange;
    this.slctDateAfterStore = eventDateEndRange;
     const startMonthFormat = new Date(eventDateStartRange).getMonth();
     const endMonthFormat = new Date(eventDateEndRange).getMonth();

     const startMonthYearFormat = new Date(eventDateStartRange).getFullYear() || "";
     const endMonthYearFormat = new Date(eventDateEndRange).getFullYear() || '';

     const startMonth = startMonthFormat && months.find((i) => i.value === startMonthFormat)?.name || '';
    
     const endMonth = endMonthFormat && months.find((i) => i.value === endMonthFormat)?.name || '';
    
    this.setState((prevState) => ({
      startMonthName: hasPrevData
        ? ''
        : (startMonth && endMonth ? `${startMonth}-${startMonthYearFormat}` : prevState.startMonthName),

      endMonthName: hasPrevData
        ? ''
        : (startMonth && endMonth ? `${endMonth}-${endMonthYearFormat}` : prevState.endMonthName),

      divDataDisabled: hasPrevData ? 'none' : 'block',
      isSearchForId: hasPrevData,
      btnDisabled: false,
      startDate: hasPrevData ? '' : eventDateStartRange,
      endDate: hasPrevData ? '' :eventDateEndRange,
    }));


    
    this.txtName.setValue(hasPrevData ? '' : this.capitalizeWord(firstNameOrNickName));
    this.txtLastName.setValue(hasPrevData ? '' : this.capitalizeWord(lastNameOrPaternalName));
    this.motherName.setValue(hasPrevData ? '' : this.capitalizeWord(motherName));
    this.selection.setSelectedValue(hasPrevData ? 'Todos los eventos' : eventType);
    
  }

  componentDidMount() {
 
    
    if (this.props?.filterProductSearchResultStore?.events && commonUtil.getChannel() === 'web') {
      this.hasStoreData();
    }

  }


  

  componentDidUpdate(prevProps, prevState) {

    const prevResponse = prevProps.filterProductSearchResult;
    const currentResponse = this.props.filterProductSearchResult;

    const hasNewResponse =
      prevResponse !== currentResponse && currentResponse?.status?.status === "success";

    const isEmptyResult =
      Array.isArray(currentResponse?.events) &&
      currentResponse.events.length === 0;

    if (hasNewResponse && isEmptyResult) {
      this.warning.setMessage(
        'Sin resultados encontrados. Rectifica los datos ó ingresa una nueva búsqueda de mesa de regalos.'
      );
    }
    const eventIdDidChange = this.state.eventId !== prevState.eventId;
    const isSearchForIdDidChange = this.state.isSearchForId !== prevState.isSearchForId;
    if (eventIdDidChange || isSearchForIdDidChange) {
      if (this.state.isSearchForId && /^\d{8}$/.test(this.state.eventId)) {
        this.enableButton();
      }
    }
  }

  updateStateReorderBtn = () => {
    this.setState({ ...this.state, eventsReorderBtn: !this.state.eventsReorderBtn });
  }
  setValueOption = (opt) => {
      this.setState({ selectedEventType: opt.id });
  }
  render() {
    const { eventCategoryType, filterProductSearchResult, filterProductSearchResultStore, extraData, lables, eventcategory } = this.props;
    //const { storeList, createEventObject } = this.pr;ops
    const { status = {}, totalResultsMatchedCount } = filterProductSearchResult || {};
    const { errorMessage } = status || {};
    const { eventCategoriesInfo = { } } = eventCategoryType || {};

    this.errorMessageForEventData = !!(totalResultsMatchedCount === '0');
    this.errorForEventData = filterProductSearchResult && ((status.errorMessage) || (errorMessage));

    if (eventcategory && eventcategory.data) {
      const eventList = eventcategory.data.eventConfigurations;
      let event = '';
      if (eventList) {
        event = eventList.filter((even) => {
          if (even.name === this.currentEvent) {
            return even;
          }
          return null;
        });
      }
      this.calendar.minDays = 10;//parseInt(event[0].minDays, 10);
      this.calendar.maxDays = 20;//parseInt(event[0].maxDays, 10);
    }

    const channel = commonUtil.getChannel();
    const constChannels = commonUtil.getClientConstForChannel();
    const isWap = channel === constChannels.WAP;
    const brand = commonUtil.getBrand();
    const colors = { LP: '#E10098', GAP: '#122344', PB: '#970400', PBK: '#74b0e2', WS: '#e81818', WLM: '#ed2724', TRU: '#007bff' };

    const {
      celebrationEventTypes = [],
      openEventTypes = [],
      celebrationEventTypesInactive = [],
      openEventTypesInactive = [],
    } = eventCategoriesInfo;
    
    // const dateValue = this._CalenderSample && this._CalenderSample.state && this._CalenderSample.state.date ?
    //   this._CalenderSample.state.date : this._CalenderSample.props.value;

    const currentDate = new Date();
    const availableDays = parseInt(this.calendar.minDays, 10) + parseInt(this.calendar.maxDays, 10);
    const minDate = new Date(currentDate.setDate(currentDate.getDate() + this.calendar.minDays));
    const newCurrentDate = new Date();
    const maxDate = new Date(newCurrentDate.setDate(newCurrentDate.getDate() + availableDays));

    const textInputAttr = {
          textClassName: 'form-control',
          textPlaceholder: commonUtil.getLabel(lables.createEventStep2, 'createEventStep2.eventdate.label'),
          textHtmlId: 'txtEventDate',
          textRequired: true,
        };

    const events = [
      ...celebrationEventTypes,
      ...openEventTypes,
      ...openEventTypesInactive,
      ...celebrationEventTypesInactive,
    ];
    const eventTypes = [
      { id: 'Todos los eventos', value: 'Todos los eventos', labelResourceId: "Todos los eventos" },
      { id: 'Bebé', value: 'Bebé', labelResourceId: "Bebé" },
      { id: 'Boda', value: 'Boda', labelResourceId: "Boda" },
      { id: 'XV años', value: 'XV años', labelResourceId: "XV años" },
      { id: 'Bautizo', value: 'Bautizo', labelResourceId: "Bautizo" },
      { id: 'Cumpleaños', value: 'Cumpleaños', labelResourceId: "Cumpleaños" },
      { id: 'Open House', value: 'Open House', labelResourceId: "Open House" },
      { id: 'Mascotas', value: 'Mascotas', labelResourceId: "Mascotas" },
      { id: 'Otras Ceremonias Religiosas', value: 'Otras Ceremonias Religiosas', labelResourceId: "Otras Ceremonias Religiosas" },
      { id: 'Otros', value: 'Otros', labelResourceId: "Otros" },
    ];
    // const reorderedEventTypes = [ ...eventTypes.filter(e => e.id === this.state.selectedEventType),...eventTypes.filter(e => e.id !== this.state.selectedEventType)];

    if (this.warning && this.errorForEventData && this.errorMessageForEventData) {
      this.warning.setMessage(this.errorForEventData);
    }

    // eventTypes?.map((event) => {
    //   const eventType = {};
    //   eventType.id = event.name;
    //   eventType.value = event.name;
    //   eventType.labelResourceId = event.name;
    //   return eventTypes.push(eventType);
    // });

    const renderWeb = () => (
      <div className='col-md-12 event_search_web_container' id="event_search_form_container" style={{marginBottom: this.props?.emptyResultsTable ? '60px' : '0'}}>
        <div className='warning_container_event_search_form'>
        <Warning
          type="error"
          style={{ marginBottom:"1%", backgroundColor: '#FFE6E6' }}
          onClose
          ref={warning => this.warning = warning}
        />
        </div>

        <div className='block1 col-md-3'>
          <div>
            <h4 id='head4'> ¿Cómo quieres buscar el evento? </h4>
          </div>
          <div className='section2'>
            <div className='form1'>
              <div style={{display:'flex', alignItems:'flex-start', gap:'8px'}}>
                <div style={{display:'flex',alignItems:'flex-start', gap:'8px'}}>
                  <input
                    name="btnRadio"
                    value="id"
                    type="radio"
                    id="btnRadioForIdEvent"
                    checked={this.state.isSearchForId === true}
                    style={{ accentColor: `${colors[brand]}`,}}
                    onChange={event => this.handleSwitchRadio(event)}
                  />
                  <div className='field_1'>
                    <label htmlFor="btnRadioForIdEvent" id='field1'>
                      Por el número de evento
                    </label>
                  </div>
                </div>
                
              </div>
              <div id="divForIdEvent" style={{ display: `${this.state.isSearchForId ? ' block' : 'none'}`,width:"100%" }} >
                <div className='text_input_id_event'>
                  <TextInput
                    className="inputMaterial p-l-10"
                    labelClassName="placeHolderMaterial"
                    htmlId="eventId"
                    name="eventId"
                    label="Número de evento"
                    required="true"
                    star="*"
                    maxlength="8"
                    // style={{margin:'0px', width:'250px'}}
                    onChange={(event) => { this.handleOnChangeBtn(event); }}
                    onKeyPress={(event) => { this.handleAllowOnlyDigitDesktop(event); }}
                    onPaste={(event) => { this.handleOnPasteInput(event); }}
                    ref={eventId => this.eventId = eventId}
                    parentClassName = "text_input_id_parent"
                  />
                  <div style={{padding:'0px 12px', textAlign:'end',margin:'0px'}}>
                    <span>{this.eventId && this.eventId.getValue().length > 0 ? `${(this.eventId.getValue().length)}/8 ` : '0/8'}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className='form2'>
              <div className='form2-div'>
                <div className='field_2_data'>
                  <input
                  name="btnRadio"
                  value="data"
                  type="radio"
                  id="btnRadioForData"
                  checked={this.state.isSearchForId === false}
                  // style={{ accentColor: `${colors[brand]}`}}
                  onChange={event => this.handleSwitchRadio(event)}
                />
                <label htmlFor="btnRadioForData" id='field1'> Por nombre y apellido </label>
                </div>
                <div id="divForData" style={{ display: `${this.state.divDataDisabled}` }} >
                  <div>
                    <div style={{ display: 'flex', flexDirection:'column' }}>
                <TextInput
                  className="inputMaterial p-l-10"
                  labelClassName="placeHolderMaterial searchLabelWeb"
                  // style={{ width: '260px' }}
                  htmlId="txtName"
                  name="txtName"
                  maxlength="100"
                  label="Nombre"
                  required="true"
                  onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                  onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                  onChange={(event) => { this.handleOnChangeBtn(event); }}
                  ref={txtName => this.txtName = txtName}
                  parentClassName = {this.state.showFieldLevelError && "textInputError" }
                />
                <TextInput
                  className="inputMaterial p-l-10"
                  labelClassName="placeHolderMaterial searchLabelWeb"
                  // style={{ width: '260px' }}
                  htmlId="txtLastName"
                  name="txtLastName"
                  maxlength="100"
                  label="Primer apellido"
                  defaultValue={filterProductSearchResultStore.lastNameOrPaternalName || ''}
                  required="true"
                  onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                  onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                  onChange={(event) => { this.handleOnChangeBtn(event); }}
                  ref={txtLastName => this.txtLastName = txtLastName}
                  parentClassName = {this.state.showFieldLevelError && "textInputError"}
                />
                <TextInput
                  className="inputMaterial p-l-10"
                  labelClassName="placeHolderMaterial searchLabelWeb"
                  // style={{ width: '260px' }}
                  htmlId="motherName"
                  name="motherName"
                  maxlength="100"
                  label="Segundo apellido"
                  defaultValue={filterProductSearchResultStore.motherName || ''}
                  required="true"
                  onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                  onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                  onChange={(event) => { this.handleOnChangeBtn(event); }}
                  ref={motherName => this.motherName = motherName}
                  parentClassName = {this.state.showFieldLevelError && "textInputError"}
                />
                </div>
                <div style={{ width: '' }}>
                  <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '8px', color:"#000"}} className='eventsearch-eventtypes'> ¿Que tipo de evento estas buscando? </p>
                <SelectionTab
                  id="slcEventTypes"
                  classname="cSelect searchSelectWeb"
                  options={eventTypes}
                  optionCaption=""
                  optionText={'labelResourceId'}
                  optionValue={'id'}
                  value={this.state.selectedEventType}
                  disable={eventTypes.length < 0}
                  ref={(selection) => { this.selection = selection; }}
                  src={commonUtil.getAssetURL() + '/images/expand_more.svg'}
                  handleSelectedOption={e => this.setValueOption(e)}
                />
                </div>
                
               <div className='eventDate-text-main'>
                  <p className='eventDate-text'>Fecha estimada del evento</p>
                </div>
               {this.state.MonthRangePicker &&  <MonthRangePicker startDate={this.state.startDate} endDate={this.state.endDate} setStartDateAndEndDate = {this.setStartDateAndEndDate} enableMonthRangePicker={this.enableMonthRangePicker}/> }
                <div className='eventDate-container' onClick={this.enableMonthRangePicker}>
                    {(this.state?.startMonthName && this.state?.endMonthName) &&
                     <div className='eventDate-container-text'>
                      {`${this.state?.startMonthName} / ${this.state?.endMonthName}`}
                    </div>}
                    <div className={ `${this.state?.startMonthName && this.state?.endMonthName ? "eventDate-Range-text": "eventDate-container-text"}`}>Rango de fecha del evento</div>
                    <div className='eventDate-container-img'>
                      <img src={commonUtil.getAssetURL() + '/images/date_range.svg'} />
                    </div>
                </div>
                
                  </div>
                </div>
              </div>
            </div>
            <div className='form3'>
              <div style={{display:'flex', width:'100%', height:'48px',padding:'0',justifyContent:'center',alignItems:'center',gap:'4px'}}>
                <InputButton
                  buttonAttr={{
                    classname: 'btnPrimary size-Full',
                    cssStyle: {
                      width: '100%',
                      background: this.state.btnDisabled ? '#D8D8D8' : `${colors[brand]}`,
                    },
                    id: 'btnHandleSearch',
                    name: 'search',
                    type: 'button',
                    value: 'Buscar',
                    autoFocus: false,
                    disabled: this.state.btnDisabled,
                    onClickHandler: this.handleBtnSearch,
                  }}
                />
              </div>
            </div>

          </div>

        </div>


        <div className={`block2 col-md-9 ${(this.props?.emptyResultsTable) ? 'empty-block2' : ""}`}>
          <h1 class="heading listasDeSearch">Listas de regalos</h1>
          <div className='events_heading_list_container'>
            <h1 class="heading1">Evento</h1>
            <h1 class="heading2">Festejados</h1>
            <h1 class="heading3">Fecha</h1>
            <h1 class="heading4">Listas</h1>
          </div>
          <div>
            {this.props?.filterProductSearchResultStore?.events?.length > 1 ?
              <SearchResults
                eventsReorderBtn={this.state.eventsReorderBtn}
                updateStateReorderBtn={this.updateStateReorderBtn}
              />
              : <div className="noResults_container">
                <h2 className="noResultsText_one">Encuentra una mesa de regalos </h2>
                <img src={commonUtil.getAssetURL() + '/images/eventsearchimage.svg'} alt="icon_search" className="icon_search_img" />
                <h2 className='noResultsText_two'>Puedes buscarla por nombre y</h2>
                <h2 className='noResultsText_two'>  apellidos, o por el número del evento.</h2>
              </div>
            }
          </div>
          {/* <ResultsTable /> */}
          {/* {(this.props.emptyResultsTable && !this.props.filterProductSearchResultStore.events) || extraData.length === 0
              ? <ResultsTable />
              : 
          } */}
        </div>
        {/* <div className="paginationContainer">
          <Pagination paginationInfo={paginationInfo} onPageChange={onPageChange} />
        </div> */}
      </div>
    );

    const renderWap = () => (
      <div
        style={{
          position: 'relative',
          padding: '0 16px',
          display: 'flex',
          flexDirection: 'column',
          // gap: '28px',
        }}
        className='wap_event_search_container'
      >
        <Warning
          type="error"
          style={{ margin: '0' }}
          text={this.errorMessage}
          ref={warning => this.warning = warning}
        />

        <h4 style={{ fontWeight: '600' }} className='heading_WAP_search'>¿Cómo quieres buscar el evento?
          <p
            style={{
              display: 'block',
              marginTop: '10px',
            }} className='smalll'
          >Selecciona una forma de búsqueda</p>
        </h4>
        <div
          style={{
            flex: '1',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
            }}
          >
            <input
              name="btnRadio"
              value="id"
              type="radio"
              id="btnRadioForIdEvent"
              checked={this.state.isSearchForId === true}
              style={{
                accentColor: `${colors[brand]}`,
                marginRight: '10px',
              }}
              onChange={event => this.handleSwitchRadio(event)}
            />
            <div>
              <label htmlFor="btnRadioForIdEvent" style={{ fontSize: '16px', fontWeight: '400' }} className='porEl_wap'>
                Por el número de evento
              </label>
            </div>
          </div>
          <div id="divForIdEvent" style={{ display: `${this.state.divIdDisabled}` }} >
            <div>
              <TextInput
                className="inputMaterial p-l-10"
                labelClassName="placeHolderMaterial"
                parentClassName='text_input_eventID_wap'
                htmlId="eventId"
                name="eventId"
                label="Número de evento"
                required="true"
                type="number"
                star="*"
                inputValue={this.state.eventId}
                onKeyDown={this.handleEventIdKeyDownWap}
                onChange={this.handleEventIdChangeWap}
                onPaste={this.handleEventIdPasteWap}
                ref={eventId => this.eventId = eventId}
                min="0"
                inputMode="numeric"
                pattern="[0-9]*"
                style={{margin:'0px'}}
              />
              <div style={{padding:'0px 12px', textAlign:'end',margin:'0px'}}>
                <span className='events_count_wap'>{this.eventId && this.eventId.getValue().length > 0 ? `${(this.eventId.getValue().length)}/8 ` : '0/8'}</span>
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
            }}
          >
            <input
              name="btnRadio"
              value="data"
              type="radio"
              id="btnRadioForData"
              checked={this.state.isSearchForId === false}
              style={{
                accentColor: `${colors[brand]}`,
                marginRight: '10px',
              }}
              onChange={event => this.handleSwitchRadio(event)}
            />
            <div>
              <label htmlFor="btnRadioForData" style={{ fontSize: '16px', fontWeight: '400' }} className='porEl_wap'>
                Por nombre y apellido
              </label>
            </div>
          </div>
          <div id="divForData" style={{ display: `${this.state.divDataDisabled}` }} >
            <div >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <TextInput
                  className="inputMaterial p-l-10"
                  labelClassName="placeHolderMaterial searchLabelWap"
                  htmlId="txtName"
                  name="txtName"
                  maxlength="100"
                  label="Nombre"
                  required="true"
                  // channel="wap"
                  onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                  onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                  onChange={(event) => { this.handleOnChangeBtn(event); }}
                  ref={txtName => this.txtName = txtName}
                />
                <TextInput
                  className="inputMaterial p-l-10"
                  labelClassName="placeHolderMaterial searchLabelWap"
                  htmlId="txtLastName"
                  name="txtLastName"
                  maxlength="100"
                  label="Primer apellido"
                  required="true"
                  // channel="wap"
                  onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                  onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                  onChange={(event) => { this.handleOnChangeBtn(event); }}
                  ref={txtLastName => this.txtLastName = txtLastName}
                />
                <TextInput
                  className="inputMaterial p-l-10"
                  labelClassName="placeHolderMaterial searchLabelWap "
                  parentClassName="inputMargin"
                  htmlId="maternalName"
                  name="motherName"
                  maxlength="100"
                  label="Segundo apellido"
                  required="true"
                  // channel="wap"
                  onKeyPress={(e) => { this.handleAllowOnlyAlpha(e); }}
                  onPaste={(e) => { this.onPasteFuncOnlyAlpha(e); }}
                  onChange={(event) => { this.handleOnChangeBtn(event); }}
                  ref={motherName => this.motherName = motherName}
                />
              </div>
              {/* <div style={{ width: '310px' }}>
                <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '18px', marginTop:'18px' }}>
                  ¿Que tipo de evento estas buscando?
                </p>
                <SelectionTab
                  id="slcEventTypes"
                  classname="cSelect"
                  style={{ marginTop: '0px', marginBottom: '8px', borderBottom :'none' }}
                  options={eventTypes}
                  optionCaption="Todos los eventos"
                  optionText={'labelResourceId'}
                  optionValue={'value'}
                  disable={eventTypes.length < 0}
                  ref={(selection) => { this.selection = selection; }}
                />
              </div> */}

               <div style={{ width: '100%' }}>
                <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '18px', marginTop:'18px' , color:" rgba(0, 0, 0, 1)"}}>
                  ¿Que tipo de evento estas buscando?
                </p>
               
                <div className='selection_wap_search_container' onClick={() => this.setState({ shareModal: true })}>
                   {(this.state?.selectedEventType != "Todos los eventos") &&
                     <div className='eventDate-container-text'>
                      {`${_.find(eventTypes, ['id', this.state?.selectedEventType])?.value}`}
                    </div>}
                    <div className={ `${this.state?.selectedEventType !="Todos los eventos"  ? "eventDate-Range-text": "eventDate-container-text"}`}>Todos los eventos</div>
                    <img src={commonUtil.getAssetURL() + '/images/expand_more.svg'} className='selection_wap_img' />
                </div>
                 { this.state.shareModal  && <GiftListConfigureWapModal
                        headerClassName="evnt-modal-header-giftList"
                        titleClassName="evnt-modal-title-giftList"
                        closeIconClassName="evnt-modal-close-icon-giftList"
                        title="Selecciona el tipo de mesa"
                        bodyClassName="evnt-modal-body-giftList"
                        closeModal={() => this.setState({ shareModal: false })}
                    > 
                       {eventTypes && eventTypes.length > 0 ?
                    ([...eventTypes]
                      .sort((a, b) => {
                        if (a.id === this.state.selectedEventType) return -1;
                        if (b.id === this.state.selectedEventType) return 1;
                        return 0;
                      }).map(
                        (option, index) => <div key={index} style={{ color: `${this.state.selectedEventType === option.id ? "#C0C0C0" : ""}` }} className="evnt-modal-option-giftList" onClick={() => {
                          this.setState({ shareModal: false, selectedEventType: option.id, btnDisabled: false });
                          this.setValueOption(option)
                        }}> {option.value}</div>)) : null}
                          
                    </GiftListConfigureWapModal>}
              </div>
                
                 <div style={{ width: '100%' }}>
                  <p style={{ fontSize: '16px', fontWeight: '400', marginBottom: '18px', marginTop:'18px' , color:" rgba(0, 0, 0, 1)"}}>
                      Fecha estimada del evento
                  </p>
                 

                 <div className='selection_wap_search_container' onClick={this.enableMonthRangePicker}>
                  {(this.state?.startMonthName && this.state?.endMonthName) &&
                     <div className='eventDate-container-text'>
                      {`${this.state?.startMonthName} / ${this.state?.endMonthName}`}
                    </div>}
                    <div className={ `${this.state?.startMonthName && this.state?.endMonthName ? "eventDate-Range-text": "eventDate-container-text"}`}>Rango de fecha del evento</div>
                    <div className='eventDate-container-img'>
                      <img src={commonUtil.getAssetURL() + '/images/date_range.svg'} />
                    </div>
                </div>
                  { this.state.MonthRangePicker  && <GiftListConfigureWapModal
                        headerClassName="evnt-modal-header-giftList"
                        titleClassName="evnt-modal-title-giftList"
                        closeIconClassName="evnt-modal-close-icon-giftList"
                        title="Rango de fecha del evento"
                        bodyClassName="evnt-modal-body-giftList calendar_wap_body"
                        closeModal={() => this.setState({ MonthRangePicker: false })}
                    > 
                      <MonthRangePicker startDate={this.state.startDate} endDate={this.state.endDate} setStartDateAndEndDate = {this.setStartDateAndEndDate} enableMonthRangePicker={this.enableMonthRangePicker}/>    
                    </GiftListConfigureWapModal>}

                  </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', margin: '10px 0 20px 0', width:'100%' }}>
          <InputButton
            buttonAttr={{
              classname: 'btnPrimary size-Full',
              cssStyle: { background: this.state.btnDisabled ? '#D8D8D8' : `${colors[brand]}` },
              id: 'btnHandleSearch',
              name: 'search',
              type: 'button',
              value: 'Buscar',
              autoFocus: false,
              disabled: this.state.btnDisabled,
              onClickHandler: this.handleBtnSearch,
            }}
          />
        </div>
      </div>
    );

    return (!isWap ? renderWeb() : renderWap());
  }
}

const mapStateToProps = state => ({
  filterProductSearchResultStore: state.searchResult.filterProductSearchResult,
  extraData: state.searchResult.extraData,
});

const mapDispatchToProps = dispatch => ({
  rangeOfDateEvent: updateRangeDate => (
    dispatch({ type: 'EVENT_DATE_RANGE', payload: updateRangeDate })
  ),
  cleanStateWarning: () => (
    dispatch({ type: 'CLEAN_STATE_WARNING' })
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventSearchForm);
